import { Component, EventEmitter, forwardRef, Input, Output, ViewChild } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, Validator } from '@angular/forms';
import { ListViewItem } from 'app/components/common/listViewItem';

type switchSize = 'small' | 'medium' | 'large';

@Component({
    selector: 'psm-toggle-switch',
    templateUrl: 'toggleSwitch.component.html',
    styleUrls: ['toggleSwitch.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => ToggleSwitchComponent)
        }
    ]
})
export class ToggleSwitchComponent implements ControlValueAccessor {
    private static _inc = 0;

    private _value: any;
    @Input()
    public get value() {
        return this._value;
    }

    public set value(value) {
        if (value === this.value) { return; }
        this._value = value;
        this.valueChange.emit(value);
        if (this.registeredOnChange) {
            this.registeredOnChange(this.value);
        }
    }

    @Output() public valueChange = new EventEmitter<any>();

    @Input() public buttons?: ListViewItem[] = [
        { key: true, label: 'actions.on' },
        { key: false, label: 'actions.off' }
    ];

    @Input() public name?: string = `toggleSwitch_${ToggleSwitchComponent._inc++}`;
    @Input() public size?: switchSize = 'medium';
    @Input() public disabled: boolean = false;

    private registeredOnChange: any;
    private registeredOnTouched: any;

    public get cssSize() {
        switch (this.size) {
            case 'small':
                return 'sm';
            case 'medium':
                return 'md';
            case 'large':
                return 'lg';
            default:
                return '';
        }
    }

    public writeValue(obj: any): void {
        this.value = obj;
    }

    public registerOnChange(fn: any): void {
        this.registeredOnChange = fn;
    }

    public registerOnTouched(fn: any): void {
        this.registeredOnTouched = fn;
    }

    public setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    private onChange(value: any) {
        this.value = value;

        if (this.registeredOnChange) {
            this.registeredOnChange(value);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/common/toggleSwitch/toggleSwitch.component.ts